// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

//---- JavintoAppPages
require("./packs/content/content_assets")
require("./packs/content/content_pages")

require("./packs/global");
require("./packs/global_bootstrap");